/**
 * DEPLOYEMENT URLS
 */

const BASE_URL = "https://askitout.vercel.app";
const SERVER_BASE_URL = "https://askitout-backend.onrender.com";

/**
 * DEVELOPMENT URLS
 */

// const BASE_URL = "http://localhost:3000";
// const SERVER_BASE_URL = "http://localhost:5000";

export {
    BASE_URL,
    SERVER_BASE_URL
}
